import React from 'react';

/**
 * Header de página del Design System — sólo título y descripción, sobre fondo
 * blanco (sin eyebrow de categoría ni caja gris). Reutilizable por todas las
 * páginas (Typography, Colors, Spacing, …).
 */
export interface PageHeaderProps {
  title: string;
  description: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, description }) => (
  <header className="flex max-w-[800px] flex-col gap-3">
    <h1 className="text-[36px] font-bold leading-[41px] text-[#262626]">{title}</h1>
    {/* `whitespace-pre-line`: respeta los saltos de línea (\n) de la descripción
        sin afectar las de una sola línea. */}
    <p className="whitespace-pre-line text-[16px] leading-[21px] text-[#5a5a5a]">{description}</p>
  </header>
);
